import React from "react";

// Ways of Seeing & Being (the classic JKZ attitudes)
const ROWS = [
  {
    name: "Non-judging",
    desc: "Seeing experience as it is, without immediately labeling it good or bad.",
    practice:
      "For one minute, note: 'pleasant', 'unpleasant', or 'neutral' instead of judging.",
  },
  {
    name: "Patience",
    desc: "Letting things unfold in their own time.",
    practice: "Choose one small thing today to let take the time it takes.",
  },
  {
    name: "Beginner’s mind",
    desc: "Meeting this moment as if for the first time.",
    practice:
      "Pick a familiar activity and do it as if you’ve never done it before.",
  },
  {
    name: "Trust",
    desc: "Leaning into your own inner wisdom and experience.",
    practice:
      "Notice one situation where you can trust your direct experience.",
  },
  {
    name: "Non-striving",
    desc: "Letting go of trying to get somewhere else.",
    practice:
      "During a short sit, let the practice be complete already, exactly as it is.",
  },
  {
    name: "Acceptance",
    desc: "Allowing things to be as they are (for now).",
    practice: "Silently repeat: 'For now, this is here too.'",
  },
  {
    name: "Letting go",
    desc: "Releasing what you can’t hold onto anyway.",
    practice:
      "On the exhale, imagine setting something down, just for this breath.",
  },
];

export default function SkillsLibraryTab() {
  return (
    <section className="card lg section">
      <div className="section-head">
        <h2 className="h2">Ways of Seeing & Being</h2>
        <span className="xs muted">
          Not skills to master, but lenses to try on.
        </span>
      </div>

      <div className="table-wrap">
        <table className="tbl">
          <thead>
            <tr>
              <th style={{ width: "18%" }}>Way</th>
              <th>Description</th>
              <th style={{ width: "32%" }}>Micro-practice</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r) => (
              <tr key={r.name}>
                <td className="sm" style={{ fontWeight: 600 }}>
                  {r.name}
                </td>
                <td className="sm">{r.desc}</td>
                <td className="xs muted">{r.practice}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
